// Current calendar month used for invoicing confirmations.
// Key matches the backend's `YYYY-MM` stamp.
export const currentInvoicePeriod = () => {
  const now = new Date();
  return {
    key: `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`,
    label: now.toLocaleString("en-NZ", { month: "long" }),
  };
};
